import axios from 'axios'

axios.defaults.withCredentials = true
axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN'
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.timeout = 15000 // 15 secs
axios.defaults.baseURL = import.meta.env.VITE_API_URL

function syncCsrfHeaderFromCookie() {
  const csrfToken = document.cookie
    .split('; ')
    .find((row) => row.startsWith('csrftoken='))
    ?.split('=')[1]

  if (csrfToken) {
    axios.defaults.headers.common['X-CSRFTOKEN'] = csrfToken
  } else {
    delete axios.defaults.headers.common['X-CSRFTOKEN']
  }
}

axios.interceptors.request.use((config) => {
  syncCsrfHeaderFromCookie()

  if (axios.defaults.headers.common['X-CSRFTOKEN']) {
    config.headers = config.headers || {}
    config.headers['X-CSRFTOKEN'] = axios.defaults.headers.common['X-CSRFTOKEN']
  }

  return config
})

console.log('HERE API Service')

// manage token expiry
// axios.interceptors.response.use(function (response) {
//     return response
//   }, function (error) {
//     console.log(error.response.data)
//     if (error.response.status === 401) {
//         const msg = "Session has expired.\nPlease log on to proceed."
//         store.dispatch("auth/storeMessage", msg);
//         router.push('/logout').catch(() => {});
//     }
//     return Promise.reject(error)
//   })

export { axios }
